import React from 'react';
import PropTypes from 'prop-types';
import L3NavigationCarousel from '../../../../common/molecules/L3NavigationCarousel';

const HorizontalSBCCarousel = (props) => {
  const {
    topCaroseldata,
    asPath,
    breadcrumbs,
    plpGenericCarouselDefaultTitle,
    brandId,
    isPLPCarouselEnabled,
    trackHorizontalPlpAnalytic,
    catLevel,
    isNewSBCImplementationEnabled,
  } = props;
  if (topCaroseldata.length < 1 || !isPLPCarouselEnabled) return null;
  return (
    <div className="horizontal-sbc-carousel">
      <L3NavigationCarousel
        categoryFilters={topCaroseldata}
        asPath={asPath}
        carouselTitle={plpGenericCarouselDefaultTitle}
        showCarousel
        showPLPGenericCarousel
        variation="desktop"
        breadcrumb={breadcrumbs}
        trackHorizontalPlpAnalytic={trackHorizontalPlpAnalytic}
        brandId={brandId}
        isHPLP={'hlp'}
        catLevel={catLevel}
        isNewSBCImplementationEnabled={isNewSBCImplementationEnabled}
        isPromoForMobile={false}
      />
      <L3NavigationCarousel
        categoryFilters={topCaroseldata}
        asPath={asPath}
        carouselTitle={plpGenericCarouselDefaultTitle}
        showCarousel
        showPLPGenericCarousel
        variation="mobile"
        breadcrumb={breadcrumbs}
        trackHorizontalPlpAnalytic={() => {}}
        brandId={brandId}
        isHPLP={'hlp'}
        catLevel={catLevel}
        isNewSBCImplementationEnabled={isNewSBCImplementationEnabled}
        isPromoForMobile
      />
    </div>
  );
};

HorizontalSBCCarousel.propTypes = {
  topCaroseldata: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.string,
      title: PropTypes.string,
      alt: PropTypes.string,
      filterTitle: PropTypes.string,
      linkAspath: PropTypes.string,
      asPath: PropTypes.string,
      linkUrl: PropTypes.string,
      url: PropTypes.string, // category image url
    })
  ),
  breadCrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  plpGenericCarouselDefaultTitle: PropTypes.string,
  asPath: PropTypes.string,
};
HorizontalSBCCarousel.defaultProps = {
  breadCrumbs: [],
  topCaroseldata: [],
  plpGenericCarouselDefaultTitle: '',
  asPath: '',
};
export default HorizontalSBCCarousel;
